import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import styles from './Stepper.module.scss';
import usePrevious from '../../../hooks/usePrevious';
import AnimationWrapper from '../AnimationWrapper';

const Stepper = ({ activeStep = -1, steps }) => {
  const numberSteps = steps.length;
  const previousActiveStep = usePrevious(activeStep);

  const [currentStep, setCurrentStep] = useState(-1);

  useEffect(() => {
    if (activeStep - currentStep === 0) setCurrentStep(activeStep);
    else setCurrentStep(0);
  }, [activeStep, currentStep]);

  return (
    <div className={styles['stepper-container']}>
      {steps.map((step, index) => {
        const isCurrentStep = activeStep < numberSteps
          ? index === activeStep
          : activeStep >= numberSteps;

        const isAlreadyActive = activeStep < numberSteps - 1
          ? index < activeStep
          : index < numberSteps - 1;

        const isPrevStep = previousActiveStep &&
        activeStep === previousActiveStep - 1 &&
        previousActiveStep === index;

        return (
          <div
            key={step.topLabel}
            className={classnames(styles['step-container'], {
              [styles['current-step']]: isCurrentStep,
              [styles['already-activated-step']]: isAlreadyActive,
              [styles['prev-class']]: isPrevStep,
            })}
          >
            <div className={styles['step-bar-segment']}>
              <AnimationWrapper
                isShowing={
                (isCurrentStep || isAlreadyActive) && (index < numberSteps - 1)
                }
                onHideClassName={styles.fadeSegmentOut}
                onShowClassName={styles.fadeSegmentIn}
              >

                <div key={step.topLabel} className={styles['step-bar-segment-child']} />
              </AnimationWrapper>
              <AnimationWrapper
                isShowing={
                (isCurrentStep || isAlreadyActive) && (index >= numberSteps - 1)
                }
                onHideClassName={styles.fadeLastSegmentOut}
                onShowClassName={styles.fadeLastSegmentIn}
              >

                <div key={step.topLabel} className={styles['step-bar-segment-child']} />
              </AnimationWrapper>
            </div>
            <div className={styles['step-labels-container']}>
              <div className={styles['step-top-label']}>{step.topLabel}</div>
              <div className={styles['step-bottom-label']}>
                {step.bottomLabel}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

Stepper.propTypes = {
  activeStep: PropTypes.number,
  steps: PropTypes.arrayOf(
    PropTypes.shape({
      topLabel: PropTypes.string.isRequired,
      bottomLabel: PropTypes.string.isRequired,
    }),
  ).isRequired,
};

export default Stepper;
